import { render, staticRenderFns } from "./ArticlesColumn.vue?vue&type=template&id=49d17b8b&scoped=true"
import script from "./ArticlesColumn.vue?vue&type=script&lang=js"
export * from "./ArticlesColumn.vue?vue&type=script&lang=js"
import style0 from "./ArticlesColumn.vue?vue&type=style&index=0&id=49d17b8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d17b8b",
  null
  
)

export default component.exports